import React from 'react';
import { useIntl } from 'react-intl';

import { ConnectionSettings } from '../../../api/configurations/oauth2connection/types';
import { CodeEditor, FieldBlock } from '../../ui';
import { CodeWrapper } from './style';
import { defaultSettingsObject } from './utils';

type Props = {
  oAuthFieldsSettings: ConnectionSettings | undefined;
  setSchema: React.Dispatch<React.SetStateAction<string>>;
};

export const SettingsFields = ({ oAuthFieldsSettings, setSchema }: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <FieldBlock title={intl.formatMessage({ id: 'navigation.settings.settings.title' })}>
      <CodeWrapper data-test-id="oauth2-settings-code-editor">
        <CodeEditor
          initialValue={JSON.stringify(oAuthFieldsSettings || defaultSettingsObject, null, '\t')}
          onChange={(value) => {
            setSchema(value);
          }}
          mode="javascript"
          height={180}
        />
      </CodeWrapper>
    </FieldBlock>
  );
};
